import { get } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import {
  FANTASY_INSIDER_UPDATE_SETTINGS,
  FANTASY_INSIDER_RESET,
  FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS,
  FANTASY_INSIDER_SET_PLAYERS,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  API_CALL_REQUEST
} from '../constants/actionTypes';
import {
  FANTASY_INSIDER_LOAD_PROJECTIONS,
  FANTASY_INSIDER_SAVE_PROJECTION
} from '../constants/apiTypes';

const initialState = {
  players: null,
  isInitialised: false,
  settings: {
    avoidQuestionable: false,
    avoidWarning: false,
    avoidLow100s: false,
    ignoreProjections: false,
    numLineUps: 10,
    minSalary: 0,
    salaryCap: null,
    uniquePlayers: 2,
    minCeiling: 0,
    maxPlayersPerTeam: null,
    maxExposurePerPlayer: 100,
    numPlayersForTeamStacking: 0,
    portfolioMethod: 'unique',
    teamStacking: [],
    globalDev: 0,
    teamsDev: undefined
  },
  projections: []
};

export default createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => {
    switch (action.api) {
      case FANTASY_INSIDER_SAVE_PROJECTION:
        return {
          isSaving: true
        };
      case FANTASY_INSIDER_LOAD_PROJECTIONS:
        return {
          isLoading: true
        };
      default:
        return null;
    }
  },
  [API_CALL_SUCCESS]: (state, action) => {
    switch (action.api) {
      case FANTASY_INSIDER_SAVE_PROJECTION:
        return {
          isSaving: false
        };
      case FANTASY_INSIDER_LOAD_PROJECTIONS:
        return {
          isLoading: false,
          projections: action.data || []
        };
      default:
        return null;
    }
  },
  [API_CALL_FAILURE]: (state, action) => {
    switch (action.api) {
      case FANTASY_INSIDER_SAVE_PROJECTION:
        return {
          isSaving: false
        };
      case FANTASY_INSIDER_LOAD_PROJECTIONS:
        return {
          isLoading: false
        };
      default:
        return null;
    }
  },
  [FANTASY_INSIDER_UPDATE_SETTINGS]: (state, { settings }) => ({
    settings: { ...state.settings, ...settings }
  }),
  [FANTASY_INSIDER_SET_PLAYERS]: (state, { players }) => ({
    players,
    isInitialised: true
  }),
  [FANTASY_INSIDER_RESET]: () => initialState,
  [FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS]: (state, { settings } = {}) => ({
    settings: {
      ...state.settings,
      maxExposurePerPlayer: initialState.settings.maxExposurePerPlayer,
      teamStacking: initialState.settings.teamStacking,
      numPlayersForTeamStacking: initialState.settings.numPlayersForTeamStacking,
      portfolioMethod: get('portfolioMethod', settings) || initialState.settings.portfolioMethod
    }
  })
});
